import React from "react";
import { VscRefresh } from "react-icons/vsc";
import { Button } from "semantic-ui-react";
import { createerrorlog } from "../modules/Graphql/errorloggraphql";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service here
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    const addData = {
      error: error.toString(),
      pageurl: window.location.href,
      date: new Date(),
    };
    createerrorlog(addData)
      .then((result) => {
        // console.log("result");
      })
      .catch((e) => {
        // console.log("result", e);
      });
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  handleRedirection = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <>
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                height: "20rem",
              }}
              src="../static/images/ErrorBoundaryImage.png"
              alt="error occured"
              title="Error Boundary"
            />
            <div
              style={{
                fontSize: "2rem",
                fontWeight: "600",
                marginBottom: "2rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "2rem",
              }}
            >
              <span>Whoops!</span>
              <span>Something went wrong :(</span>
            </div>
            {/* <p>Will get back soon </p> */}
            <Button
              basic
              color="red"
              onClick={() => {
                this.handleRedirection();
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                Refresh <VscRefresh />
              </div>
            </Button>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
